function VoucherManagement() {

  let voucherManagement = [
    {
      name: "Voucher Management",
      icon: "Voucher Management",
      logoName: "MyAccounts",
      // flag: "voucherRequired",
      displayService: "voucher",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        path: "/index/voucher-management",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];

    return dashboardArr;
  };

  const voucherMapping = () => {
    const profileArr = [
      {
        path: "/index/voucher-mapping",
        name: "Voucher Mapping",
        icon: "Voucher Mapping",
        logoName: "voucher mapping",
        flag: "VOUCHER MAPPING",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };

  const voucherTransaction = () => {
    const mybanksArr = [
      {
        path: "/index/voucher-transaction",
        name: "Voucher Transaction",
        icon: "Voucher Transaction",
        logoName: "voucher transaction",
        flag: "VOUCHER TRANSACTION",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mybanksArr[0].flag])
    // ) {
    return mybanksArr;
    // } else {
    //   return "";
    // }
  };

  const vouchers = () => {
    const mycardsArr = [
      {
        path: "/index/vouchers",
        name: "Vouchers",
        icon: "Voucher",
        logoName: "Voucher",
        flag: "VOUCHERS",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };

  const redeem = () => {
    const mycardsArr = [
      {
        path: "/index/redeem",
        name: "Redeem",
        icon: "redeem voucher",
        logoName: "redeem voucher",
        flag: "REDEEM",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[mycardsArr[0].flag])
    // ) {
    return mycardsArr;
    // } else {
    //   return "";
    // }
  };
  let a = dashboard();
  let b = voucherMapping();
  let c = voucherTransaction();
  let d = vouchers();
  let e = redeem();

  voucherManagement[0].items = [...a, ...b, ...c, ...d, ...e];

  return voucherManagement;
}

export default VoucherManagement;
